// Keep initial-image bandwidth first, then prepare at most two nearby detail
// images at a time. Existing responsive sources and original pixels stay intact.
(() => {
  if (!('IntersectionObserver' in window)) return;
  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    const pending = new Set();
    let active = 0;
    const pump = () => {
      for (const image of pending) {
        if (active >= 2) break;
        pending.delete(image);
        if (image.complete || !image.getClientRects().length) continue;
        observer.unobserve(image);
        active++;
        const finish = () => {
          image.removeEventListener('load', finish);
          image.removeEventListener('error', finish);
          active--;
          pump();
        };
        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', finish, { once: true });
        image.loading = 'eager';
      }
    };
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) pending.add(entry.target);
        else pending.delete(entry.target);
      }
      pump();
    }, { rootMargin: '1800px 0px' });
    document.querySelectorAll('.pdtabs__content img[loading="lazy"]').forEach(image => observer.observe(image));
  };
  const first = document.querySelector('media-gallery .product-media__image[loading="eager"]');
  if (!first || first.complete) start();
  else {
    first.addEventListener('load', start, { once: true });
    first.addEventListener('error', start, { once: true });
  }
})();
